import type { UI } from '@/v2/types';
import { useEffect } from 'react';
import { Box } from '@qga/roo-ui/components';

import ConditionsMarkdown from '@/v2/../components/ConditionsMarkdown';
import { Container } from '@/v2/components/layout/Container';
import { Layout } from '@/v2/components/layout/Layout';
import bookingConditions from '@/v2/markdown/bookingConditions.md';
import { dataLayer } from './utils/dataLayer';

interface Props {
  importantInformation: Array<UI.ImportantInformation>;
  navigation: Array<UI.Navigation>;
  informationMessage: UI.Message | null;
  warningMessage: UI.Message | null;
  marketingMessage: UI.MarketingMessage | null;
}

const BookingConditionsView = (props: Props) => {
  useEffect(() => {
    dataLayer();
  }, []);

  return (
    <Layout {...props}>
      <Box py="10">
        <Container>
          <ConditionsMarkdown markdown={bookingConditions} />
        </Container>
      </Box>
    </Layout>
  );
};

export default BookingConditionsView;
